import script from "./MobileCodeVerify.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileCodeVerify.vue?vue&type=script&setup=true&lang=js"

import "./MobileCodeVerify.vue?vue&type=style&index=0&id=6ac1c321&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac1c321"]])

export default __exports__